import { Component, inject, OnInit, Signal } from '@angular/core';
import { ContentComponent } from '../../../components/content/content.component';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectCases, selectLoading } from '../../../store/selectors/my-cases.selectors';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from '../../../common/alert/alert.component';
import { FilterDataPipe } from '../../../pipes/filter-data.pipe';
import { DatePipe } from '@angular/common';
import { CaseEntityAppEntityCaseEntityRead } from '../../../openapi';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { loadMyCaseList } from '../../../store/actions/my-cases.actions';

@Component({
  selector: 'app-my-cases-list-page',
  standalone: true,
  imports: [
    ContentComponent,
    BreadcrumbsComponent,
    RouterLink,
    FormsModule,
    AlertComponent,
    FilterDataPipe,
    DatePipe,
    SpinnerComponent
  ],
  templateUrl: './my-cases-list-page.component.html'
})
export class MyCasesListPageComponent implements OnInit {

  private store$: Store = inject(Store);

  public cases: Signal<CaseEntityAppEntityCaseEntityRead[]> = this.store$.selectSignal(selectCases);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public filterValue: string = '';

  public ngOnInit(): void {
    this.store$.dispatch(loadMyCaseList());
  }

}
